import { CardCorners, PartnerProgramCard } from '@setplex/arcana'
import type { PartnerProductFormatted } from '~/entities/partner-product'
import type { ViewRow } from '~/widgets/DynamicModule'
import { getCardFonts } from '../lib'

export const PartnerCard = ({
  item,
  row,
}: {
  item: PartnerProductFormatted
  row: ViewRow
}) => {
  const { coverImageUrl, free, rented, name, id, labelPrice } = item

  const {
    appearance: {
      style: { posterSize },
    },
  } = row

  const { titleFont } = getCardFonts(posterSize)

  return (
    <a href={`/partner-program/${id}`}>
      <PartnerProgramCard
        corners={CardCorners.CORNERS_25}
        posterUrl={coverImageUrl}
        free={free}
        description={name}
        purchaseTitle={labelPrice}
        rented={rented}
        descriptionFont={titleFont}
      />
    </a>
  )
}
